// QALYON – Desktop drag-to-scroll for product-card swipe + prevent click on drag (PESO-feel)
(function () {
  function initSwipeDrag(container) {
    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let dragged = false;
    let lastX = 0;
    let suppressClickUntil = 0;

    const DRAG_THRESHOLD = 20; // px (wenn du "snappiger" willst: 16)
    const MINI_SWIPE = 25;     // 20–35 feinjustieren

    // Prevent image ghost-drag
    container.querySelectorAll("img").forEach((img) => {
      img.setAttribute("draggable", "false");
    });

    // Pointer down (replaces mousedown)
    container.addEventListener("pointerdown", (e) => {
      // Only primary button for mouse
      if (e.pointerType === "mouse" && e.button !== 0) return;

      isDown = true;
      dragged = false;

      startX = e.clientX;
      lastX = e.clientX;
      startScrollLeft = container.scrollLeft;

      container.classList.add("is-dragging");

      // Keeps dragging stable even if pointer leaves the element
      try {
        container.setPointerCapture(e.pointerId);
      } catch (_) {}
    });

    // Pointer move (replaces window mousemove)
    container.addEventListener(
      "pointermove",
      (e) => {
        if (!isDown) return;

        lastX = e.clientX;

        const dx = e.clientX - startX;
        if (Math.abs(dx) > DRAG_THRESHOLD) dragged = true;

        // IMPORTANT: only scroll if it is a real drag
        if (dragged) {
          e.preventDefault();
          container.scrollLeft = startScrollLeft - dx;
        }
      },
      { passive: false }
    );

    // Pointer up (replaces window mouseup)
    container.addEventListener("pointerup", (e) => {
      if (!isDown) return;
      isDown = false;

      container.classList.remove("is-dragging");

      try {
        container.releasePointerCapture(e.pointerId);
      } catch (_) {}

      // Nur wenn wirklich gezogen wurde -> Slide wechseln
      if (dragged) {
        const dxTotal = lastX - startX; // + rechts, - links
        const slideW = container.clientWidth;

        const currentIndex = Math.round(container.scrollLeft / slideW);
        let targetIndex = currentIndex;

        if (dxTotal <= -MINI_SWIPE) targetIndex = currentIndex + 1;
        if (dxTotal >= MINI_SWIPE) targetIndex = currentIndex - 1;

        const maxIndex = container.children.length - 1;
        targetIndex = Math.max(0, Math.min(maxIndex, targetIndex));

        container.scrollTo({
          left: targetIndex * slideW,
          behavior: "smooth",
        });

        // block only the ghost-click right after a drag (not the next real click)
        suppressClickUntil = Date.now() + 250;
      } else {
        suppressClickUntil = 0;
      }

      dragged = false;
    });

    // Safety: if pointer is cancelled (e.g. browser gesture), end drag
    container.addEventListener("pointercancel", () => {
      if (!isDown) return;
      isDown = false;
      dragged = false;
      container.classList.remove("is-dragging");
    });

    // Prevent click-through only inside the short ghost-click window
    container.addEventListener(
      "click",
      (e) => {
        if (Date.now() < suppressClickUntil) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true // capture phase so we stop the <a> click
    );
  }

  function boot() {
    // Desktop only
    if (window.matchMedia("(min-width: 750px)").matches) {
      document
        .querySelectorAll(".product-card .qalyon-mobile-swipe")
        .forEach((el) => {
          if (el.dataset.qalyonSwipeInit === "1") return; // avoid double init
          el.dataset.qalyonSwipeInit = "1";
          initSwipeDrag(el);
        });
    }
  }

  // Run now + when Shopify renders sections (theme editor / dynamic updates)
  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();